import React from "react";
import CommonButtons from "src/shared/components/CommonButtons";

interface Props {
  onClick: () => void;
  Buttondata: any;
}

const AddConfigurationButton: React.FC<Props> = ({ onClick, Buttondata }) => {
  return (
    <div id="Addconfiguration" >
      <CommonButtons label="ADD CONFIGURATION" onClick={onClick}/>
    </div>
  );
};

export default AddConfigurationButton;
